function canonical(value) {
    return JSON.stringify(value, (_key, item) => item && typeof item === 'object' && !Array.isArray(item)
        ? Object.fromEntries(Object.entries(item).sort(([a], [b]) => a.localeCompare(b))) : item);
}
/** A public receipt may omit sensitive answers, but may not change other answer data. */
export function matchesInteractionReceipt(original, receipt) {
    if (!original || !receipt || typeof original !== 'object' || typeof receipt !== 'object')
        return false;
    const expected = structuredClone(original);
    const actual = receipt;
    if (expected.kind !== actual.kind)
        return false;
    if (actual.kind === 'question' && Array.isArray(expected.answers) && Array.isArray(actual.answers)) {
        if (expected.answers.length !== actual.answers.length)
            return false;
        for (let index = 0; index < actual.answers.length; index++) {
            const answer = actual.answers[index];
            if (answer.redacted === true) {
                if (answer.questionId !== expected.answers[index].questionId || answer.selectedValues?.length !== 0 || 'customText' in answer)
                    return false;
                expected.answers[index] = { questionId: answer.questionId, selectedValues: [], redacted: true };
            }
        }
    }
    if (actual.kind === 'form' && actual.action === 'submit' && Array.isArray(actual.redactedFields)) {
        if (new Set(actual.redactedFields).size !== actual.redactedFields.length || !expected.values || !actual.values)
            return false;
        for (const field of actual.redactedFields) {
            if (typeof field !== 'string' || !Object.hasOwn(expected.values, field) || Object.hasOwn(actual.values, field))
                return false;
            delete expected.values[field];
        }
        expected.redactedFields = actual.redactedFields;
    }
    return canonical(expected) === canonical(actual);
}
//# sourceMappingURL=interaction-receipt.js.map